import {
  ifElse,
  either,
  isNil,
  isEmpty,
  always,
  pipe,
  toPairs,
  filter,
  map,
  join,
} from 'ramda'

/**
 * makeQueryParams :: Object -> String
 *  It takes an object, and make it into query param string
 */
export default ifElse(
  either(isNil, isEmpty),
  always(''),
  pipe(
    toPairs,
    filter(([__, v]) => !isNil(v) && !isEmpty(v)),
    map(([k, v]) => [k, encodeURIComponent(v)]),
    map(join('=')),
    join('&'),
    queryParams => (!queryParams ? '' : `?${queryParams}`),
  ),
)
